<div class="notification" [ngClass]="type">
  <div class="notification-header">
    <div class="notification-icon-title">
      <hyperkit-icon
        [icon]="iconClass"
        size="large"
        [color]="type"
      ></hyperkit-icon>
      <hyperkit-typography
        class="title"
        variant="body"
        size="lg"
        color="primary"
        >{{ header }}</hyperkit-typography
        >
    </div>
    @if (closeable) {
      <button class="close-button" (click)="onClose()">
        <span>×</span>
      </button>
    }
  </div>
  <div class="notification-body">
    @if (body) {
      <hyperkit-typography class="title" variant="body" size="md" color="body">{{
        body
      }}</hyperkit-typography>
    }
    <ng-content></ng-content>
  </div>
  @if (showActions) {
    <div class="notification-actions">
      <button class="action-button primary">Primary</button>
      <button class="action-button secondary">Secondary</button>
    </div>
  }
</div>
